module.exports = __webpack_public_path__ + "static/media/link_cranked.6366fd76.webp";